// helpers.js

// format integer part with commas, keep decimals as typed (no rounding)
export const formatTyping = (str) => {
  if (str == null) return '';
  let s = String(str).replace(/[^\d.,]/g, '');
  const parts = s.split('.');
  if (parts.length > 2) s = parts.shift() + '.' + parts.join('');
  const [intPartRaw, decPart] = s.split('.');
  const intDigits = (intPartRaw || '').replace(/,/g, '');
  const intWithCommas = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart !== undefined ? `${intWithCommas}.${decPart}` : intWithCommas;
};

export const toFixed2 = (n) =>
  new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .format(Number.isFinite(n) ? n : 0);

export const parseNumeric = (str) => {
  if (typeof str !== 'string') return 0;
  const raw = str.replace(/,/g, '').trim();
  const val = parseFloat(raw);
  return Number.isFinite(val) ? val : 0;
};

export const detectUS = () => {
  try {
    const lang = (navigator?.language || navigator?.languages?.[0] || '').toUpperCase();
    return lang.includes('US');
  } catch {
    return false;
  }
};

export const formatDisplayDate = (iso, isUS) => {
  if (!iso) return '';
  const dt = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(dt.getTime())) return '';
  const dd = String(dt.getDate()).padStart(2, '0');
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const yyyy = dt.getFullYear();
  return isUS ? `${mm}/${dd}/${yyyy}` : `${dd}/${mm}/${yyyy}`;
};

/**
 * VAT model:
 * - net is 100% (base)
 * - tax = net * rate
 * - amount (gross) = net + tax
 */
export const recomputeFromNet = (net, taxRateStr) => {
  const rate = parseFloat(String(taxRateStr).replace('%', '')) / 100 || 0;
  const tax = net * rate;
  const amount = net + tax;
  return { amount, taxAmount: tax, netAmount: net };
};

/**
 * Inverse VAT calculation from gross:
 * - net = amount / (1 + rate)
 * - tax = amount - net
 */
export const recomputeFromAmount = (amount, taxRateStr) => {
  const rate = parseFloat(String(taxRateStr).replace('%', '')) / 100 || 0;
  const net = (1 + rate) > 0 ? amount / (1 + rate) : amount;
  const tax = amount - net;
  return { amount, taxAmount: tax, netAmount: net };
};

/**
 * Custom tax calculation from tax amount:
 * - If editing amount: net = amount - tax, total = amount
 * - If editing net: amount = net + tax, total = net
 * @param {number} baseValue - Either amount or net, depending on lastEdited
 * @param {number} taxAmount - The custom tax amount
 * @param {string} lastEdited - 'amount' or 'net' to indicate which field was last edited
 */
export const recomputeFromTaxAmount = (baseValue, taxAmount, lastEdited) => {
  if (lastEdited === 'amount') {
    // amount was edited, so: net = amount - tax
    const net = baseValue - taxAmount;
    return { amount: baseValue, taxAmount, netAmount: net };
  } else {
    // net was edited, so: amount = net + tax
    const amount = baseValue + taxAmount;
    return { amount, taxAmount, netAmount: baseValue };
  }
};
